import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import axios from "axios";

export const localApiUrl = `${window.location.protocol}//${window.location.hostname}:8000/api/v1/`;
export const apiUrl = 'https://alcrm.pythonanywhere.com/api/v1/';
const Alxorazmiy = window.location.hostname

let url = apiUrl
if (Alxorazmiy === '86.62.3.138') {
  url = localApiUrl
}

axios.defaults.baseURL = url

export const baseUrl = url


export const api = fetchBaseQuery({
  baseUrl,
  headers: {
    Authorization: `Bearer ${sessionStorage.getItem("token")}`,
  },
});
